import { createDrawerSlice, drawerActions, drawerSelectors } from './slices/drawer'
import type { FullStore } from './slices/types'

import { create } from 'zustand'

export type * from './slices/drawer'
export type { FullStore } from './slices/types'

export const useDrawerStore = create<FullStore>()((...args) => ({
    ...createDrawerSlice(...args),
}))

export const getDrawerStore = () => useDrawerStore.getState()

export { drawerSelectors, drawerActions }
